import { createSlice } from '@reduxjs/toolkit';
import extraReducers from 'src/redux/scheduling/extra-reducer';
import reducers from 'src/redux/scheduling/reducers';
import { schedulingInitialState } from 'src/redux/scheduling/types';

const schedulingSlice = createSlice({
  name: 'scheduling',
  initialState: schedulingInitialState,
  reducers,
  extraReducers,
});

export const {
  setWorkOrders,
  loadSchedulingData,
  toggleTechnicianSelection,
  deselectAllTechnicians,
  selectAllTechniciansAction,
  toggleMapVisibility,
  toggleWorkOrderLocked,
  setLockedSuggestions,
  addLockedSuggestion,
  removeLockedSuggestion,
  resetOptimizer,
  addBlockoutBlock,
  updateBlockoutBlock,
  removeBlockoutBlock,
  removeSuggestedWO,
  addSuggestedWO,
  setSelectedDate,
  setTimelineView,
  setWorkOrderAvailabilityRequestPending,
  addPendingAvailabilityRequestUuids,
  setPendingAvailabilityRequestUuids,
  removePendingAvailabilityRequestUuids,
  clearPendingAvailabilityRequestUuids,
  applyBulkAvailabilityRequestFailures,
  setRoutingRequestId,
  setIsOptimizerRunning,
  setHoveredWorkOrderId,
  showSchedulingAlert,
  clearSchedulingAlert,
  addUrgentWorkOrder,
  dismissEmergencyRescheduleProposal,
  approveEmergencyRescheduleProposal,
  updateSchedulingWorkOrderPriority,
  updateSchedulingWorkOrderTrip,
  setSchedulingWorkOrderStatus,
  deleteSchedulingWorkOrder,
  resetSchedulingState,
  setSchedulingTimezone,
} = schedulingSlice.actions;

export default schedulingSlice.reducer;
